function dynamicList() {
    var lists = {
        "data": {
            "TUNIS": {
                "EL MEDINA": [1000],
                "BAB BHAR": [1000],
                "BAB SOUIKA": [1006],
                "CARTHAGE": [2016],
                "CITE EL KHADRA": [1003],
                "EL HRAIRIA": [2087],
                "EL KABBARIA": [2053],
                "EL KRAM": [2015],
                "EL MENZAH": [1004],
                "EL OMRANE": [1005],
                "OMRANE SUPERIEUR": [1091],
                "EL OUERDIA": [1009],
                "ESSIJOUMI": [2072],
                "ETTAHRIR": [2042],
                "EZZOUHOUR": [2052],
                "JEBEL JELLOUD": [2023],
                "LA GOULETTE": [2060],
                "LA MARSA": [2078],
                "LE BARDO": [2000],
                "SIDI EL BECHIR": [1089],
                "SIDI HASSINE": [1095]
            },
                "ARIANA": {
                    "ARIANA VILLE": [2080],
                    "ETTADHAMEN": [2041],
                    "KALAAT LANDLOUS": [2022],
                    "LA SOUKRA": [2036],
                    "MNIHLA": [2094],
                    "RAOUED": [2056],
                    "SIDI THABET": [2020]
                },
            "BEN AROUS": {
                "BEN AROUS": [2013],
                "BOU MHEL EL BASSATINE": [2097],
                "EL MOUROUJ": [2074],
                "EZZAHRA": [2034],
                "FOUCHANA": [2082],
                "HAMMAM CHATT": [1164],
                "HAMMAM LIF": [2050],
                "MEGRINE": [2033],
                "MOHAMMADIA": [1145],
                "MORNAG": [2090],
                "NOUVELLE MEDINA": [2063],
                "RADES": [2040]
            },
            "MANNOUBA": {
                "BORJ EL AMRI": [1142],
                "DOUAR HICHER": [2086],
                "EL BATAN": [1114],
                "JEDAIDA": [1124],
                "MANNOUBA": [2010],
                "MORNAGUIA": [1110],
                "OUED ELLIL": [2021],
                "TEBOURBA": [1130]
            },
            "NABEUL": {
                "BENI KHALLED": [8021],
                "BENI KHIAR": [8060],
                "BOU ARGOUB": [8040],
                "DAR CHAABANE EL FEHRI": [8011],
                "EL HAOUARIA": [8045],
                "EL MIDA": [8044],
                "GROMBALIA": [8030],
                "HAMMAM EL GHEZAZ": [8025],
                "HAMMAMET": [8050],
                "KELIBIA": [8090],
                "KORBA": [8070],
                "MENZEL BOUZELFA": [8010],
                "MENZEL TEMIME": [8080],
                "NABEUL": [8000],
                "SOLIMAN": [8020],
                "TAKELSA": [8031]
            },
            "ZAGHOUAN": {
                "ZAGHOUAN": [1100],
                "BIR MECHARGA": [1141],
                "EL FAHS": [1140],
                "NADHOUR": [1160],
                "HAMMAM ZRIBA": [1152],
                "SAOUAF": [1115]
            },
            "BIZERTE": {
                "BIZERTE NORD": [7000],
                "BIZERTE SUD": [7011],
                "EL ALIA": [7016],
                "GHAR EL MELH": [7033],
                "GHEZALA": [7040],
                "JARZOUNA": [7021],
                "JOUMINE": [7020],
                "MATEUR": [7030],
                "MENZEL BOURGUIBA": [7050],
                "MENZEL JEMIL": [7080],
                "RAS JEBEL": [7070],
                "SEJNANE": [7010],
                "TINJA": [7032],
                "UTIQUE": [7060]
            },
            "BEJA": {
                "BEJA NORD": [9000],
                "BEJA SUD": [9021],
                "NEFZA": [9010],
                "AMDOUN": [9030],
                "MEDJEZ EL BAB": [9070],
                "TESTOUR": [9060],
                "TEBOURSOUK": [9040],
                "GOUBELLAT": [9080],
                "THIBAR": [9022]
            },
            "JENDOUBA": {
                "AIN DRAHEM": [9130],
                "BALTA BOU AOUENE": [8116],
                "BOU SALEM": [8170],
                "FERNANA": [8140],
                "GHARDIMAOUI": [8160],
                "JENDOUBA": [8100],
                "JENDOUBA NORD": [8189],
                "OUED MLIZ": [8115],
                "TABARKA": [8110]
            },
            "LE KEF": {
                "DAHMANI": [7170],
                "EL KSOUR": [7160],
                "JERISSA": [7114],
                "KALAA EL KHASBA": [7113],
                "KALAAT SINANE": [7130],
                "LE KEF EST": [7100],
                "LE KEF OUEST": [7117],
                "LE SERS": [7180],
                "NEBEUR": [7110],
                "SAKIET SIDI YOUSSEF": [7120],
                "TAJEROUINE": [7150],
                "TOUIREF": [7112]
            },
            "SILIANA": {
                "BARGOU": [6170],
                "BOU ARADA": [6180],
                "EL AROUSSA": [6116],
                "GAAFOUR": [6110],
                "KESRA": [6114],
                "LE KRIB": [6120],
                "MAKTHAR": [6140],
                "ROHIA": [6150],
                "SIDI BOU ROUIS": [6113],
                "SILIANA NORD": [6100],
                "SILIANA SUD": [6123]
            },
            "KAIROUAN": {
                "BOU HAJLA": [3180],
                "CHEBIKA": [3112],
                "CHERARDA": [3116],
                "EL ALA": [3150],
                "HAFFOUZ": [3130],
                "HAJEB EL AYOUN": [3160],
                "KAIROUAN NORD": [3140],
                "KAIROUAN SUD": [3100],
                "NASRALLAH": [3170],
                "OUESLATIA": [3120],
                "SBIKHA": [3110]
            },
            "KASSERINE": {
                "EL AYOUN": [1216],
                "FERIANA": [1240],
                "FOUSSANA": [1220],
                "HAIDRA": [1221],
                "HASSI EL FRID": [1241],
                "JEDILIANE": [1280],
                "KASSERINE NORD": [1200],
                "KASSERINE SUD": [1233],
                "MEJEL BEL ABBES": [1214],
                "SBEITLA": [1250],
                "SBIBA": [1270],
                "THALA": [1210],
                "EZZOUHOUR": [1279]
            },
            "SIDI BOUZID": {
                "BEN OUN": [9120],
                "BIR EL HAFFEY": [9113],
                "CEBBALA": [9122],
                "JILMA": [9110],
                "MAKNASSY": [9140],
                "MENZEL BOUZAIENE": [9114],
                "MEZZOUNA": [9150],
                "OULED HAFFOUZ": [9180],
                "REGUEB": [9170],
                "SIDI BOUZID EST": [9100],
                "SIDI BOUZID OUEST": [9111],
                "SOUK JEDID": [9121]
            },
            "SOUSSE": {
                "AKOUDA": [4022],
                "BOU FICHA": [4010],
                "ENFIDHA": [4030],
                "HAMMAM SOUSSE": [4011],
                "HERGLA": [4012],
                "KALAA EL KEBIRA": [4060],
                "KALAA ESSGHIRA": [4021],
                "KONDAR": [4020],
                "MSAKEN": [4070],
                "SIDI BOU ALI": [4040],
                "SIDI EL HENI": [4025],
                "SOUSSE JAOUHARA": [4061],
                "SOUSSE RIADH": [4041],
                "SOUSSE MEDINA": [4000]
            },
            "MONASTIR": {
                "BEKALTA": [5090],
                "BEMBLA": [5021],
                "BENI HASSEN": [5014],
                "JEMMAL": [5020],
                "KSAR HELAL": [5070],
                "KSIBET EL MEDIOUNI": [5031],
                "MOKNINE": [5050],
                "MONASTIR": [5000],
                "OUERDANINE": [5010],
                "SAHLINE": [5012],
                "SAYADA LAMTA BOU HAJAR": [5035],
                "TEBOULBA": [5080],
                "ZERAMDINE": [5040]
            },
            "MAHDIA": {
                "BOU MERDES": [5110],
                "CHORBANE": [5130],
                "EL JEM": [5160],
                "HEBIRA": [5113],
                "KSOUR ESSAF": [5180],
                "CHEBBA": [5170],
                "MAHDIA": [5100],
                "MELLOULECH": [5114],
                "OULED CHAMEKH": [5120],
                "SIDI ALOUANE": [5190],
                "SOUASSI": [5140],
                "AJIM": [4135]
            },
            "SFAX": {
                "AGAREB": [3030],
                "BIR ALI BEN KHELIFA": [3040],
                "EL AMRA": [3036],
                "EL HENCHA": [3010],
                "ESSKHIRA": [3050],
                "GHRAIBA": [3034],
                "JEBENIANA": [3080],
                "KERKENAH": [3070],
                "MAHRAS": [3060],
                "MENZEL CHAKER": [3020],
                "SAKIET EDDAIER": [3011],
                "SAKIET EZZIT": [3021],
                "SFAX EST": [3072],
                "SFAX SUD": [3042],
                "SFAX MEDINA": [3000]
            },
            "GAFSA": {
                "EL GUETTAR": [2180],
                "EL KSAR": [2111],
                "EL MDHILLA": [2170],
                "GAFSA NORD": [2196],
                "GAFSA SUD": [2100],
                "METLAOUI": [2130],
                "MOULARES": [2110],
                "REDEYEF": [2120],
                "SIDI AICH": [2131],
                "SNED": [2190]
            },
            "TOZEUR": {
                "TOZEUR": [2200],
                "DEGUECHE": [2260],
                "HEZOUA": [2223],
                "NEFTA": [2240],
                "TAMEGHZA": [2212]
            },
            "KEBILI": {
                "DOUZ": [4260],
                "EL FAOUAR": [4264],
                "KEBILI NORD": [4280],
                "KEBILI SUD": [4200],
                "SOUK EL AHAD": [4230]
            },
            "GABES": {
                "EL HAMMA": [6020],
                "EL METOUIA": [6010],
                "GABES MEDINA": [6000],
                "GABES SUD-OUEST": [6031],
                "GHANNOUCHE": [6021],
                "MARETH": [6080],
                "MATMATA": [6070],
                "MENZEL HABIB": [6030],
                "NOUVELLE MATMATA": [6044],
                "BELKHIR": [2115]
            },
            "MEDENINE": {
                "BEN GUERDANE": [4160],
                "BENI KHEDACHE": [4110],
                "HOUMET ESSOUK": [4180],
                "MEDENINE NORD-SUD": [4100],
                "MIDOUN": [4116],
                "SIDI MAKHLOUF": [4191],
                "ZARZIS": [4170]
            },
            "TATAOUINE": {
                "BIR LAHMAR": [3212],
                "DHEHIBA": [3253],
                "GHOMRASSEN": [3220],
                "REMADA": [3240],
                "ESSMAR": [3223],
                "TATAOUINE NORD-SUD": [3200]
            }
        }
    }
    return lists;
}

export { dynamicList }